import ApiGateway from "../../explorer/services/ApiGateway";
import { Basket } from "../../explorer/types";
import { endpoints } from "../../site/configuration/endpoints";
import { BasketDetail } from "../types/Basket/BasketDetail";
import { BasketGetPartsByRef, BasketPartByRef } from "../types/Basket/BasketPartsByRef";
import { BasketItemDTO, BasketItem } from "../types/Basket/BasketItems";
import { CustomerUserDto } from "../types/SpareParts/CustomerUserDto";
import { AvailabilityPartRequestDTO, AvailabilityPartResponseDTO } from "../types/Basket/AvailabilityRequest";

export class BasketService {
    public getBaskets = (brand: string): Promise<Basket[]> => {
        return new Promise<Basket[]>((resolve, reject) => {
            ApiGateway()
                .get<Basket[]>(
                    endpoints.basket.baskets.replace("{brand}", brand)
                )
                .then((result) => {
                    resolve(result.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    public setCurrentBasket = (
        brand: string,
        basketId: number
    ): Promise<Basket[]> => {
        return new Promise<Basket[]>((resolve, reject) => {
            ApiGateway()
                .put<Basket[]>(
                    endpoints.basket.setCurrentBasket.replace("{brand}", brand),
                    { Id: basketId, Name: "---" }
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public getBasketDetails = (
        brand: string,
        lang: string,
        getPrice: "0" | "1" | "2" = "0"
    ): Promise<BasketDetail> => {
        return new Promise<BasketDetail>((resolve, reject) => {
            ApiGateway()
                .get<BasketDetail>(
                    endpoints.basket.basketDetails
                        .replace("{brand}", brand)
                        .replace(
                            "{getPrice}",
                            getPrice === "2" ? "0" : getPrice
                        ) +
                        "?lang=" +
                        lang
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };
    public getCachedBasketDetails = (
        brand: string,
        lang: string
    ): Promise<BasketDetail> => {
        return new Promise<BasketDetail>((resolve, reject) => {
            ApiGateway()
                .get<BasketDetail>(
                    endpoints.basket.cachedBasketDetails.replace(
                        "{brand}",
                        brand
                    ) +
                        "?lang=" +
                        lang
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public setNavContext = (
        brand: string,
        part: BasketItemDTO,
        forAllPart: string = "0",
        lang: string
    ): Promise<BasketDetail> => {
        return new Promise<BasketDetail>((resolve, reject) => {
            ApiGateway()
                .put<BasketDetail>(
                    endpoints.basket.updateBasketItemNavContext
                        .replace("{brand}", brand)
                        .replace("{forAllPart}", forAllPart) +
                        "?lang=" +
                        lang,
                    part
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public setNewQty = (
        brand: string,
        part: BasketItemDTO,
        lang: string
    ): Promise<BasketItem> => {
        return new Promise<BasketItem>((resolve, reject) => {
            ApiGateway()
                .put<BasketItem>(
                    endpoints.basket.updateBasketItem.replace(
                        "{brand}",
                        brand
                    ) +
                        "?lang=" +
                        lang,
                    part
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public createBasket = (brand: string, name: string): Promise<Basket[]> => {
        return new Promise<Basket[]>((resolve, reject) => {
            ApiGateway()
                .put(endpoints.basket.createBasket.replace("{brand}", brand), {
                    Name: name,
                })
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public mergeBasket = (
        brand: string,
        basketId: number
    ): Promise<Basket[]> => {
        return new Promise<Basket[]>((resolve, reject) => {
            ApiGateway()
                .put(endpoints.basket.mergeBasket.replace("{brand}", brand), {
                    basketId: basketId,
                })
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public renameBasket = (
        brand: string,
        id: number,
        name: string
    ): Promise<Basket[]> => {
        return new Promise<Basket[]>((resolve, reject) => {
            ApiGateway()
                .put(endpoints.basket.renameBasket.replace("{brand}", brand), {
                    Id: id,
                    Name: name,
                })
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public deleteBasket = (brand: string, id: number): Promise<Basket[]> => {
        return new Promise<Basket[]>((resolve, reject) => {
            ApiGateway()
                .delete(
                    endpoints.basket.deleteBasket.replace("{brand}", brand),
                    { data: { Id: id } }
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public AddBasketItem = (part: BasketItemDTO): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            ApiGateway()
                .post(endpoints.basket.addBasketItem, part)
                .then((result) => {
                    resolve(result.data);
                })
                .catch((error) => {
                    reject(error.data.errors);
                });
        });
    };

    public AddBasketItems = (items: BasketItemDTO[]): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post(endpoints.basket.addBasketItems, items)
                .then((result) => {
                    resolve(result.data);
                })
                .catch((error) => {
                    reject(error.data.errors);
                });
        });
    };

    public RemoveBasketItem = (
        brand: string,
        itemId: string,
        lang: string
    ): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            ApiGateway()
                .delete(
                    endpoints.basket.deleteBasketItem
                        .replace("{brand}", brand)
                        .replace("{itemId}", itemId.toString()) +
                        "?lang=" +
                        lang
                )
                .then((result) => {
                    resolve("result.data");
                })
                .catch((error) => {
                    reject(error.data.errors);
                });
        });
    };

    public ClearBasket = (brand: string): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            ApiGateway()
                .delete(endpoints.basket.clearBasket.replace("{brand}", brand))
                .then((result) => {
                    resolve(result.data);
                })
                .catch((error) => {
                    reject(error.data.errors);
                });
        });
    };

    public TransferBasket = (
        brand: string,
        username: string
    ): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            ApiGateway()
                .post(
                    endpoints.basket.transferBasket
                        .replace("{brand}", brand)
                        .replace("{username}", username)
                )
                .then((result) => {
                    resolve(result.data);
                })
                .catch((error) => {
                    reject(error.data.errors);
                });
        });
    };

    public getPartByRef = (
        brand: string,
        filter: BasketGetPartsByRef,
        lang: string
    ): Promise<BasketPartByRef[]> => {
        return new Promise<BasketPartByRef[]>((resolve, reject) => {
            ApiGateway()
                .post<BasketPartByRef[]>(
                    endpoints.basket.getPartsByRef.replace("{brand}", brand) +
                        "?lang=" +
                        lang,
                    filter
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public getAvailability = (
        brand: string,
        parts: AvailabilityPartRequestDTO[]
    ): Promise<AvailabilityPartResponseDTO[]> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post<any>(
                    endpoints.basket.getAvailability.replace("{brand}",brand),  parts
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };
}
